import { useQuery } from "@tanstack/react-query";
import { getTimeline } from "@/api/program-steps/timeline";

/**
 * GET /program/{program_id}/timeline
 * Get timeline data for a specific program
 */
export function useGetTimeline(programId: string) {
  return useQuery({
    queryKey: ["timeline", programId],
    queryFn: () => getTimeline(programId),
    enabled: !!programId,
  });
}
